'use strict';

const Mn = require('backbone.marionette');
const ActionRepository = require('process/domain/repository/action/index');
const DataRepository = require('data/domain/repository/content/index');
const DiagramAction = require('system/domain/action/diagram');
const DiagramRepository = require('system/domain/repository/diagram');
const PrimaryContextProjectTemplate = require('balus/ui/template/primary-context/project.hbs');
const PrimaryContextActionTemplate = require('balus/ui/template/primary-context/action.hbs');
const PrimaryContextContentTemplate = require('balus/ui/template/primary-context/content.hbs');
const PrimaryContextDiagramTemplate = require('balus/ui/template/primary-context/diagram.hbs');

const ContextView = Mn.View.extend({
    /**
     * どの Entity (現時点では、Task もしくは Comment) に対して PrimaryContext を
     * 表示しようとしているのか判定し、判定した Entity への path を取得する責務を持ちます。
     */
    getTargetPath: function() {
        const target = this.getOption('target');
        let targetPath;
        if(target.key.kind == 'Task') {
            targetPath = `#/tasks/${target.key.id}`
        } else if(target.key.kind == 'Comment') {
            targetPath = `#/comments/${target.key.id}`
        }
        return targetPath;
    }
});

const PrimaryContextProjectView = ContextView.extend({
    /**
     * PrimaryContext が Project の場合に、Project の path と name を取得し
     * Project 用の Template に渡す責務を持ちます。
     */
    template: PrimaryContextProjectTemplate,
    templateContext: function() {
        const project = this.getOption('primaryContext');
        return {
            path: `${project.path()}${this.getTargetPath()}`,
            name: project.getName()
        };
    }
});

const PrimaryContextActionView = ContextView.extend({
    /**
     * PrimaryContext が Action の場合
     */
    template: PrimaryContextActionTemplate,
    templateContext: function() {
        const action = this.getOption('primaryContext');
        return {
            path: `${action.path()}${this.getTargetPath()}`,
            name: action.getName()
        };
    }
});

const PrimaryContextContentView = ContextView.extend({
    /**
     * PrimaryContext が Content の場合
     */
    template: PrimaryContextContentTemplate,
    templateContext: function() {
        const content = this.getOption('primaryContext');
        return {
            path: `${content.path()}${this.getTargetPath()}`,
            name: content.getName()
        };
    }
});

const PrimaryContextDiagramView = ContextView.extend({
    /**
     * PrimaryContext が Diagram の場合
     */
    template: PrimaryContextDiagramTemplate,
    templateContext: function() {
        const diagram = this.getOption('primaryContext');
        return {
            path: `${diagram.path()}${this.getTargetPath()}`,
            name: diagram.get('name')
        };
    }
});

const PrimaryContextView = Mn.View.extend({
    /**
     * primaryRelatedKey の kind からどの PrimaryContext の View を出すかを判定し、
     * Entity を取得して PrimaryContext の View に渡す責務を持ちます。
     */
    tagName: 'span',
    template: _.template('<span class="primary-context-wrapper"></span>'),
    regions: {
        wrapper: '.primary-context-wrapper'
    },

    onRender: function() {
        const context = this.getOption('context');
        const project = context.getProject();
        const contextKey = context.get().key;
        const key = this.model.getPrimaryRelatedKey();

        if((!key) || (key.toString() == contextKey.toString())) {
            return;
        }

        if(key.kind == 'Action') {
            const projectActionID = project.getActionID();
            if(key.id == projectActionID) {
                this.showChildView('wrapper', new PrimaryContextProjectView({
                    primaryContext: project,
                    target: this.model
                }));
            } else {
                ActionRepository.find(project).get(key.id)
                    .then(action => {
                        this.showChildView('wrapper', new PrimaryContextActionView({
                            primaryContext: action,
                            target: this.model
                        }));
                    });
            }
        } else if(key.kind == 'DataContent') {
            DataRepository.find(project).fetchContentOnce(key.id)
                .then(content => {
                    this.showChildView('wrapper', new PrimaryContextContentView({
                        primaryContext: content,
                        target: this.model
                    }));
                });
        } else if(key.kind == 'Diagram') {
            DiagramAction.fetchDiagram(project.id, key.id)
                .then(() => {
                    const diagram = DiagramRepository.getDiagrams({
                        context: {
                            projectId: project.id
                        }
                    }).get(key.id);
                    this.showChildView('wrapper', new PrimaryContextDiagramView({
                        primaryContext: diagram,
                        target: this.model
                    }));
                });
        }
    }
});

module.exports = PrimaryContextView;



// WEBPACK FOOTER //
// ./balus/ui/view/primary-context.js